// style
import styled, { css } from "styled-components";

/**
 * @desc 체크박스 컴포넌트
 * @param {ReactNode} children - 체크박스 옆에 표시될 텍스트
 * @param {string} className - 추가적인 클래스명
 * @param {function} onChange - 체크박스 값 변경 시 호출되는 함수
 * @param {boolean} value - 체크박스의 상태 (true: 체크, false: 체크 해제)
 * @param {string} label - 체크박스를 위한 레이블 텍스트
 * @param {boolean} disabled - 체크박스를 비활성화할지 여부
 * @returns {JSX.Element} 체크박스 컴포넌트
 */
export const CheckBox = ({
  children,
  className,
  onChange,
  value,
  label,
  disabled,
  width = "14px",
  height = "14px",
  borderRadius = "2px",
}) => {
  return (
    <CheckBoxForm className={`checkbox_form ${className}`}>
      <input
        id={label}
        type="checkbox"
        checked={value}
        onChange={onChange}
        disabled={disabled}
      />
      <label
        htmlFor={label}
        width={width}
        height={height}
        borderradius={borderRadius}
      >
        {children}
      </label>
    </CheckBoxForm>
  );
};

export const labelBaseStyles = {
  common: css`
    position: relative;
    padding-left: 28px;
    line-height: 1;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: -0.03px;
    white-space: nowrap;

    @media screen and (max-width: 768px) {
      font-size: 12px;
      padding-left: 24px;
    }

    &::before,
    &:after {
      width: 18px;
      height: 18px;

      @media screen and (max-width: 768px) {
        width: 15px;
        height: 15px;
      }
    }
  `,
  before: css`
    content: "";
    position: absolute;
    left: 0;
    width: ${({ width }) => (width === "" ? "14px" : width)};
    height: ${({ height }) => (height === "" ? "14px" : height)};
    border-radius: ${({ borderradius }) =>
      borderradius === "" ? "2px" : borderradius};
    background: ${({ theme }) => theme.color.white};
    border-radius: 20px;
  `,
  after: css`
    content: "";
    position: absolute;
    left: 0;
    width: ${({ width }) => (width === "" ? "14px" : width)};
    height: ${({ height }) => (height === "" ? "14px" : height)};
    color: ${({ theme }) => theme.color.white};
    text-align: center;
    background: ${({ theme }) => theme.color.primary};
  `,
};

const checkmarkStyles = {
  checked: css`
    content: "";
    position: absolute;
    /* top: 0;
    left: 5px; */
    top: 1px;
    left: 7px;
    width: 4px;
    height: 8px;
    border-right: 2px solid #fffefc;
    border-bottom: 2px solid #fffefc;
    transform: rotate(45deg);
    opacity: 1;
  `,
  notChecked: css`
    content: "";
    position: absolute;
    left: 1px;
    top: 0;
    left: 5px;
    width: ${({ width }) => (width === "" ? "14px" : width)};
    height: ${({ height }) => (height === "" ? "14px" : height)};
    color: ${({ theme }) => theme.color.white};
    text-align: center;
    border-radius: ${({ borderRadius }) =>
      borderRadius === "" ? "2px" : borderRadius};
  `,
};
const CheckBoxForm = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  margin-top: 16px;
  line-height: 1;

  &.necessary {
    ${({ theme }) => theme.necessary}
  }

  input[type="checkbox"] {
    width: ${({ width }) => (width === "" ? "14px" : width)};
    height: ${({ height }) => (height === "" ? "14px" : height)};
    border: 1px solid ${({ theme }) => theme.color.gray200};
    background: ${({ theme }) => theme.color.white};
    overflow: hidden;
    position: absolute;
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    width: 1px;
    height: 1px;
  }

  [type="checkbox"]:checked + label,
  [type="checkbox"]:not(:checked) + label {
    ${labelBaseStyles.common}
  }

  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:before {
    ${labelBaseStyles.before}
    border: 1px solid ${({ theme }) => theme.color.gray200};
  }

  [type="checkbox"]:checked + label:before {
    border: 1px solid ${({ theme }) => theme.color.primary};
    background: ${({ theme }) => theme.color.primary};
  }

  [type="checkbox"]:checked + label:after {
    ${labelBaseStyles.after}
    ${checkmarkStyles.checked}
  }

  [type="checkbox"]:not(:checked) + label:after {
    ${checkmarkStyles.notChecked}
  }

  input::-webkit-input-placeholder {
    color: ${({ theme }) => theme.color.gray200};
  }

  [type="checkbox"]:disabled + label {
    cursor: default;
  }
`;
